export default __webpack_public_path__ + "static/media/darkovy_poukaz_konfety.4e21cf76.jpg";